import { useState } from "react";
import "../../../assets/styles/Common.css";
import useCanvasDetection from "../../hooks/useCanvasDetection";

const StepProgress = ({ activeStep }) => {
  // const steps = ["Submit Content", "Choose Keywords", "Review Content", "Done"];
  const steps = ["Submit Content", "Select category & question type", "Generate and export questions"];

  const [currentStep, setCurrentStep] = useState(activeStep);

  // State variable to track whether the staepper is closed or not
  const [closed, setClosed] = useState(false);

  // let [checkedQuestionsArray , setCheckedQuestionsArray] = useState();

  localStorage.setItem("hideStepProgress", closed);

  const isCanvas = useCanvasDetection();
  return (
    <>
      {!isCanvas && (
        <div
          className={`bg-[#f7f7f7] shadow-md stepper-container h-full ${
            closed ? "w-auto " : "w-auto"
          } overflow`}
          >
          {closed ? (
            <button className="text-white">
              <div className="stepper flex flex-row">
                {steps.map((step, index) => (
                  <div
                  key={index}
                  className={`step ${
                    index === activeStep - 1 ? "active" : ""
                    } ${index < activeStep - 1 ? "complete" : ""} flex`}
                    >
                    <div className="step-content flex items-center">
                      {index < activeStep - 1 ? (
                        <div className="step-circle bg-[#d5d5d8] items-center flex place-content-center rounded-full border">
                          <span>{index + 1}</span>
                        </div>
                      ) : (
                        <div className="step-circle  bg-[#d5d5d8] items-center flex place-content-center rounded-full border">
                          <span>{index + 1} </span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </button>
          ) : (
            <>
              <div className="text-white  border-b-[1px] border-b-[#2d4552]  pb-1">
              </div>
              <div className="mt-[10px]">
                <div className="stepper flex flex-row">
                  {steps.map((step, index) => (
                    <div
                      key={index}
                      className={`step ${
                        index === activeStep - 1 ? "active" : ""
                      } ${index < activeStep - 1 ? "complete" : ""} flex`}
                    >
                      <div className="step-content flex items-center">
                        {index < activeStep - 1 ? (
                          <>
                            <div className="step-circle bg-[#d5d5d8]  ml-[-33px] items-center flex place-content-center rounded-full border">
                              <span className="text-white">✓</span>
                            </div>

                            <div className="step-label mx-1">{step} </div>
                          </>
                        ) : (
                          <>
                            <div className="step-circle  bg-[#d5d5d8]  ml-[-33px] items-center flex place-content-center rounded-full border">
                              <span>{index + 1}</span>
                            </div>

                            <div className="step-label mx-1">
                              {step}
                            </div>
                          </>
                        )}
                      </div>
                      {activeStep - 1 === index ? (
                        currentStep === 1 ? (
                          <button>
                            <span className=""></span>
                            {""}
                          </button>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                      {activeStep - 1 === index ? (
                        currentStep === 2 ? (
                          <button>
                            <span className=""></span>
                            {""}
                          </button>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}

                      {activeStep - 1 === index ? (
                        currentStep === 3 ? (
                          <>
                          <button>
                            <span className=""></span>
                            {""}
                          </button>
                          </>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>

  );
};

export default StepProgress;
